/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: banxia
 * @LastEditTime: 2022-11-25 17:31:24
 */
import request from '@api/request'

// banner
export const listLiveOperate = params =>
  request.get('/liveData/listLiveOperate', { params })

// 区域选择
export const getArea = params => request.get('/dictArea/getArea', { params })

// 企业端获取视频列表
export const listLiveData = params =>
  request.get('/liveData/listLiveData', { params })

// 我的收藏列表
export const listCollect = params =>
  request.get('/liveData/listCollect', { params })

// 直播详情
export const liveDataDetail = params =>
  request.get('/liveData/liveDataDetail', { params })
export const liveDataDetail2 = params =>
  request.get('/liveData/liveDataDetail2', { params })
// 收藏直播
export const collectLive = params =>
  request.get('/liveData/collectLive', { params })

// 回看视频直播
export const listLiveVideoData = params =>
  request.get('/liveData/listLiveVideoData', { params })

// 视频详情
export const getVideoDetailsById = params =>
  request.get('/videoData/getVideoDetailsById', { params })

// 观看直播次数统计
export const watchLive = params =>
  request.get('/liveData/watchLive', { params })

// 获取ip
export const getAddress = params =>
  request.get('/videoData/getAddress', { params })

// 获取直播类型列表
export const getLiveTypeList = params =>
  request.get('/liveData/getLiveTypeList', { params })

// 埋点
export const saveRecord = params =>
  request.post('/lishui-qym-ent/applyStatistics/saveRecord', params)

// 埋点 uv
export const saveUVRecord = params =>
  request.post('/lishui-qym-ent/applyUVStatistics/saveUVRecord', params)

// 分享直播（积分）
export const shareDataDetail = params =>
  request.get('/liveData/shareDataDetail', { params })

//观看、回看直播-积分
export const watchDataDetail = params =>
  request.get('/liveData/watchDataDetail', { params })
